import { useStoreMap, useUnit } from 'effector-react';
import { ComponentProps } from 'react';
import { GameCell, GameCellBgVariant } from 'entities/game';
import { sendTurn, TURN_TYPES } from 'shared/api';
import { clickSound } from 'shared/lib';
import { GAME_FIELD_GHOST_DURATION } from '../../config';
import { gameFieldModel } from '../../model';
import cls from './game-field-cell.module.scss';

export type GameFieldMultiplierProps = {
	rowIndex: number;
	columnIndex: number;
} & Omit<ComponentProps<'button'>, 'disabled'>;

export const GameFieldCell = ({ rowIndex, columnIndex, ...props }: GameFieldMultiplierProps) => {
	const [send, clickPlay] = useUnit([sendTurn, clickSound.play]);

	const variant = useStoreMap({
		store: gameFieldModel.$cells,
		keys: [rowIndex, columnIndex],
		fn: (cells, [row, column]) => cells[row][column],
	});

	const bg: GameCellBgVariant = rowIndex % 2 === 1 ? 'light' : 'default';

	return (
		<GameCell
			variant={variant}
			bgVariant={bg}
			ghostDelay={GAME_FIELD_GHOST_DURATION * rowIndex}
			ghostDuration={GAME_FIELD_GHOST_DURATION}
			classNames={{
				root: cls.gameFieldCellRoot,
			}}
			onClick={() => {
				send({
					type: TURN_TYPES.turn,
					cellIds: columnIndex,
				});

				clickPlay();
			}}
			{...props}
		/>
	);
};
